import { render, staticRenderFns } from "./BusinessHours.vue?vue&type=template&id=0c9dbda5&scoped=true"
import script from "./BusinessHours.vue?vue&type=script&lang=js"
export * from "./BusinessHours.vue?vue&type=script&lang=js"
import style0 from "./BusinessHours.vue?vue&type=style&index=0&id=0c9dbda5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9dbda5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9dbda5')) {
      api.createRecord('0c9dbda5', component.options)
    } else {
      api.reload('0c9dbda5', component.options)
    }
    module.hot.accept("./BusinessHours.vue?vue&type=template&id=0c9dbda5&scoped=true", function () {
      api.rerender('0c9dbda5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/BusinessHours.vue"
export default component.exports